export interface Event {
  HESESSIONID: string;
  eventName: HEEventName;
  serviceName: 'Mobile Manager';
  environment: string;
  itemName: string;
  itemType: HEEventItemType;
  itemAction: HEEventItemAction;
  clientDateTimeUTC: string;
  detailsJson: {
    [key: string]: any;
  };
}

export interface Response {
  success: boolean;
  responseMessage: string;
}

export enum HEEventName {
  INBOX_VIEWED = 'INBOX_VIEWED',
  NEWSFEED_VIEWED = 'NEWSFEED_VIEWED',
  CHAT_VIEWED = 'CHAT_VIEWED',
}

export const APP_NAME = 'Mobile Manager';

export enum HEEventItemType {
  PAGE = 'page',
}

export enum HEEventItemAction {
  LOAD = 'load',
}
